import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `Para quieres respondieron '${selectText}' en el n.º ${questionDisplayNumber} de ${categoryName} (Pregunta obligatoria).`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `'${selectText}' en el n.º ${questionDisplayNumber} de ${categoryName}`
            }
          )
          return `Para quieres respondieron ${messages.join(' o ')}. (Pregunta obligatoria)`
        }),
    },
    validation: {
      decimal_max_digit: 'Escriba hasta {decimalMaxDigit} decimales',
    },
  }
}
